import { Download } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DownloadButtonProps } from './types';

const DownloadButton: React.FunctionComponent<DownloadButtonProps> = ({
  title,
  onClick,
  ...props
}) => {
  const { t } = useTranslation('common');
  const renderDownloadButton = () => {
    return (
      <Tooltip title={title ?? t('download')}>
        <IconButton size='small' onClick={onClick} {...props}>
          <Download fontSize='small' />
        </IconButton>
      </Tooltip>
    );
  };

  return renderDownloadButton();
};

export default DownloadButton;
